export const HANDLE_LOGIN = "HANDLE_LOGIN";
export const SET_AUTH_USER = "SET_AUTH_USER";
export const REMOVE_AUTH_USER = "REMOVE_AUTH_USER";
